import * as amplitude from '@amplitude/analytics-browser';
import { User } from 'src/types/user';
import { Instance } from 'src/types/instance';
import { UserProperties } from 'src/types/amplitude';

const apiKey = process.env.REACT_APP_AMPLITUDE_API_KEY;

export const initAmplitude = () => {
  if (apiKey) {
    amplitude.init(process.env.REACT_APP_AMPLITUDE_API_KEY, undefined, {
      defaultTracking: false,
      minIdLength: 1,
      identityStorage: 'localStorage',
    });
  }
};

export const setUser = (user: User, instance: Instance) => {
  if (apiKey) {
    amplitude.setUserId(String(user.id));

    const identify = new amplitude.Identify();
    identify
      .set(UserProperties.INSTANCE_ID, instance.id)
      .set(UserProperties.INSTANCE_NAME, instance.name)
      .set(UserProperties.USERNAME, user.employeeInternalId);
    amplitude.identify(identify);
  }
};

export const clearUser = () => {
  if (apiKey) {
    amplitude.reset();
  }
};

export const logEvent = (
  eventName: string,
  eventProperties: Record<string, unknown>,
) => {
  if (apiKey && amplitude.getUserId()) {
    amplitude.track(eventName, {
      origin: 'WEB',
      ...eventProperties,
    });
  }
};
